module.exports = __webpack_public_path__ + "assets/img/c4.ec6cf8ab.jpg";